import { AuthenticationService } from './../../../services/authentication.service';
import {Component, HostListener} from '@angular/core';
import {EmailService} from '../../../services/email.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'search-instructions-modal',
    templateUrl: './search-instructions-modal.component.html',
    styleUrls: ['./search-instructions-modal.component.scss']
})
export class SearchInstructionsModalComponent {

    constructor(
        public es: EmailService,
        public authenticationService: AuthenticationService
    ) {}


    hideModal() {
        this.es.showSearchInstructionsModal = false;
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/email/search-instructions-modal/search-instructions-modal.component.ts